import {BaseApi, configuration}     from './base/BaseApi';
import {ResetPasswordControllerApi} from './base/api';
import {StorageKey}                 from '../util/Storage';
import {processError}               from './fetch';
// import {processError}               from './fetch';

class AccountApi extends BaseApi {
    api: ResetPasswordControllerApi;

    constructor() {
        super();
        this.api = new ResetPasswordControllerApi(configuration, configuration.basePath, this.fetch);
    }

    resetPassword(token: string, password: string, passwordConfirm: string): Promise<boolean> {
        let bean = {password: password, passwordConfirm: passwordConfirm};
        return this.api.resetPassword(bean, token).then(result => {
            return Promise.resolve(true);
        }).catch(err => {
            return processError(err);
        });
    }

    forgotPassword(email: string): Promise<boolean> {
        return this.api.forgotPassword({email: email}).then(result => {
            return Promise.resolve(true);
        }).catch(err => {
            return processError(err);
        });
    }

    login(username: string, password: string, remember: boolean): Promise<boolean> {

        const form = 'username=' + encodeURIComponent(username) + '&password=' + encodeURIComponent(password);

        const options: RequestInit = {
            method: 'POST',
            body: form,
            headers: {
                'secure-cookie': 'true',
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        };

        return this.fetch(configuration.basePath + '/providers/login?remember=' + remember, options)
            .then(() => {
                localStorage.setItem(StorageKey.Authenticated, 'true');
                return Promise.resolve(true);
            })
            .catch(() => {
                localStorage.setItem(StorageKey.ApiError, 'Incorrect Username or Password');
                return Promise.resolve(false);
            });
    }

    logout(): Promise<boolean> {

        const options: RequestInit = {method: 'GET'};

        return this.fetch(configuration.basePath + '/providers/logout', options)
            .then(() => {
                localStorage.removeItem(StorageKey.Authenticated);
                localStorage.removeItem(StorageKey.TokenExpiration);
                return Promise.resolve(true);
            })
            .catch(() => {
                return Promise.resolve(false);
            });
    }
}

export const accountApi = new AccountApi();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/api/account.ts